import { createResource } from 'react-resource-router';

import { createHttpRequest } from 'src/utils/http-request';
import { captureExceptionWithTags } from 'src/utils/sentry';

import { CONTAINERS_RESOURCE_EXPIRY } from '../constants';
import { PackagesAvailabilityResponse } from '../types';
import { urls } from '../urls';

export const packagesAvailabilityResource =
  createResource<PackagesAvailabilityResponse>({
    type: 'packages-availability',
    getKey: ({ match: { params } }) => {
      const { workspaceSlug, repositoryOwner } = params;
      const prefix = repositoryOwner || workspaceSlug;
      return `${prefix}/packages/availability`;
    },
    maxAge: CONTAINERS_RESOURCE_EXPIRY,
    getData: async ({ match: { params } }) => {
      const { workspaceSlug: workspaceSlugParam, repositoryOwner } = params;
      const workspaceSlug = repositoryOwner || workspaceSlugParam;

      if (!workspaceSlug) {
        throw new Error(
          'This resource must be rendered on a valid route with a workspace slug'
        );
      }

      const apiUrl = urls.api.internal.getPackagesAvailability(workspaceSlug);

      try {
        const response = await createHttpRequest<PackagesAvailabilityResponse>(
          'GET',
          {
            throwErrorType: 'errorObject',
          }
        )(apiUrl);

        return response;
      } catch (error: unknown) {
        if (error instanceof Error) {
          captureExceptionWithTags(error);
        }

        throw error;
      }
    },
  });
